export default "__VITE_ASSET__f$Y4dsVM__"